// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dialog-public-error {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.dl-dialog-public-error__error-text {
  font-size: 15px;
  color: var(--g-color-text-danger);
  margin-bottom: 18px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryDialogues/DialogSwitchPublic/DialogPublic/ContentError/ContentError.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAAJ;AAEI;EACI,eAAA;EACA,iCAAA;EACA,mBAAA;AAAR","sourcesContent":[".dl-dialog-public-error {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n.dl-dialog-public-error__error-text {\n  font-size: 15px;\n  color: var(--g-color-text-danger);\n  margin-bottom: 18px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
